import { apiClient, retryRequest } from './httpClient';

// Generic GET request for sync users
export async function getSyncUsers(endpoint, options = {}) {
    const requestConfig = {
        url: endpoint,
        method: 'GET',
        ...options
    };

    try {
        const response = await retryRequest(() => apiClient(requestConfig));
        return response.data;
    } catch (error) {
        const err = new Error(error.message || 'GET request failed');
        err.status = error.status || 500;
        err.endpoint = endpoint;
        err.method = 'GET';
        throw err;
    }
}

// Get sync user by ID
export async function getSyncUserById(endpoint, id, options = {}) {
    const requestConfig = {
        url: `${endpoint}/${id}`,
        method: 'GET',
        ...options
    };

    try {
        const response = await retryRequest(() => apiClient(requestConfig));
        return response.data;
    } catch (error) {
        const err = new Error(error.message || 'GET request failed');
        err.status = error.status || 500;
        err.endpoint = endpoint;
        err.method = 'GET';
        throw err;
    }
}

// POST request for sync users
export async function postSyncUser(endpoint, data = null, options = {}) {
    const requestConfig = {
        url: endpoint,
        method: 'POST',
        ...options
    };

    if (data) {
        requestConfig.data = data;
    }

    try {
        const response = await retryRequest(() => apiClient(requestConfig));
        return response.data;
    } catch (error) {
        const err = new Error(error.data || 'POST request failed');
        err.status = error.status || 500;
        err.endpoint = endpoint;
        err.method = 'POST';
        throw err;
    }
}

// PUT request for sync users
export async function putSyncUser(endpoint, data = null, options = {}) {
    const requestConfig = {
        url: endpoint,
        method: 'PUT',
        ...options
    };

    if (data) {
        requestConfig.data = data;
    }

    try {
        const response = await retryRequest(() => apiClient(requestConfig));
        return response.data;
    } catch (error) {
        const err = new Error(error.data || 'PUT request failed');
        err.status = error.status || 500;
        err.endpoint = endpoint;
        err.method = 'PUT';
        throw err;
    }
}
